import React, {useState} from 'react';
import {ScrollView, View} from 'react-native';

//////////////////////////
///////  components
import {TopTab, TopTabButton} from 'src/Modules/TabViews';

import CommunityChallenges from 'src/LandingPage/CommunityChallenges';
import Player from 'src/ScavengerHunt_v2/Challenges/Player.js';
import Treasure from 'src/ScavengerHunt_v2/Challenges/Treasure.js';
import CallSupportLine from '../../HeaderComponents/CallSupportLine';

const PlayerTreasureChallenges = () => {
  const [view, setView] = useState('hunt'); /// options are [ 'hunt', 'daily',]

  console.log('PlayerTreasureChallenges Render');

  return (
    <View style={{flex: 1}}>
      <CallSupportLine showBottomShadow />
      <TopTab>
        <TopTabButton
          text={'Hunt Challenges'}
          active={view === 'hunt'}
          handlePress={() => setView('hunt')}
        />
        <TopTabButton
          text={'Daily Challenges'}
          active={view === 'daily'}
          handlePress={() => setView('daily')}
        />
      </TopTab>
      <ScrollView style={{flex: 1}}>
        <View style={{flex: 1, paddingBottom: 60}}>
          {view === 'hunt' && (
            <View>
              <Player />
              <Treasure />
            </View>
          )}

          {view === 'daily' && <CommunityChallenges />}
        </View>
      </ScrollView>
    </View>
  );
};

export default PlayerTreasureChallenges;
